import React from 'react'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton from '@mui/material/IconButton';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';

/**
 * TablePagination component for handling pagination in a table.
 *
 * @component
  * @memberof Components
 * @param {Object} props - Component props
 * @param {Array<number>} props.rowsPerPageOptions - Available options for rows per page
 * @param {number} props.count - Total number of records
 * @param {number} props.rowsPerPage - Number of rows per page
 * @param {number} props.page - Current page index (zero-based)
 * @param {Function} props.onChangePage - Function to handle page change
 * @param {Function} props.onChangeRowsPerPage - Function to handle rows per page change
 * @param {boolean} props.rowsPageOption - Whether to show rows per page selection
 * @param {Function} props.nextPage - Function to navigate to the next page
 * @param {Function} props.previousPage - Function to navigate to the previous page
 * @param {number} props.currentPage - Current page number (one-based)
 * @param {number} props.totalPages - Total number of pages
 * @param {number} props.totalRecords - Total number of records in the dataset
 * @param {Function} props.firstPage - Function to navigate to the first page
 * @param {Function} props.lastPage - Function to navigate to the last page
 *
 * @returns {JSX.Element} A pagination component for navigating through table records.
 */
const TablePagination = ({
    rowsPerPageOptions,
    count,
    rowsPerPage,
    page,
    onChangePage,
    onChangeRowsPerPage,
    rowsPageOption,
    nextPage,
    previousPage,
    currentPage,
    totalPages,
    totalRecords,
    firstPage,
    lastPage
}) => {
    /**
       * Handles the change of the rows per page selection.
       *
       * @param {React.ChangeEvent<HTMLSelectElement>} event - The event object
       */
    const handleRowsPerPageChange = event => {
        onChangeRowsPerPage(event);
    };

    return (
        <div style={{ width: 'auto', backgroundColor: 'transparent', padding: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {
                rowsPageOption &&
                <>
                    <span>Rows per page:</span>
                    <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                        {rowsPerPageOptions.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </>
            }
            <IconButton onClick={() => firstPage()} disabled={currentPage === 1}>
                <FirstPageIcon />
            </IconButton>
            <IconButton onClick={() => previousPage()} disabled={currentPage === 1}>
                <KeyboardArrowLeftIcon />
            </IconButton>
            <span style={{ color: 'blue', fontSize: '14px' }}>Page {currentPage + ' of ' + totalPages}</span>
            <IconButton onClick={() => nextPage()} disabled={currentPage === totalPages}>
                <KeyboardArrowRightIcon />
            </IconButton>
            <IconButton onClick={() => lastPage()} disabled={currentPage === totalPages}>
                <LastPageIcon />
            </IconButton>
        </div>
    )
}

export default TablePagination